import { useSiteSettings } from "@/hooks/use-site-settings";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Sparkles, Compass, Highlighter, NotebookPen, Bookmark, PenLine } from "lucide-react";
import { fmtDate } from "@/lib/format";

export function WelcomeStrip({ user, counts }) {
  const exploreThemes = useSiteSettings().settings.explore_themes;
  const last = localStorage.getItem("qg-reader-last");
  const since = user.created_at ? fmtDate(user.created_at) : null;
  const stats = [
    { n: counts.journal, label: counts.journal === 1 ? "journal entry" : "journal entries", to: "/journal", icon: NotebookPen },
    { n: counts.highlights, label: counts.highlights === 1 ? "highlight" : "highlights", to: "/highlights", icon: Highlighter },
    { n: counts.favorites + counts.commentary_bookmarks, label: "saved", to: "/dashboard#saved", icon: Bookmark },
    { n: counts.posts, label: counts.posts === 1 ? "blog post" : "blog posts", to: "/blog/mine", icon: PenLine },
  ];
  return (
    <header className="mb-10" data-testid="dashboard-welcome">
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Dashboard</span>
      <h1 className="mt-2 font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl">Welcome, {user.name?.split(" ")[0] || "seeker"}.</h1>
      {since && <p className="mt-2 text-sm text-muted-foreground" data-testid="dashboard-member-since">Asking questions here since {since}.</p>}
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {stats.map((s) => (
          <Link key={s.label} to={s.to} data-testid={`stat-${s.label.replace(/\s+/g, "-")}`} className="group rounded-2xl border border-border bg-card p-4 transition-all hover:border-gold hover:shadow-md">
            <s.icon className="h-4 w-4 text-gold" />
            <p className="mt-2 font-serif text-3xl font-semibold text-foreground">{s.n}</p>
            <p className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground">{s.label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {last && (
          <Link to={`/read/${last}`} data-testid="dashboard-continue-reading" className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90">
            <BookOpen className="h-4 w-4" /> Continue reading {last.replace("/", " ")} <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        )}
        <Link to="/daily" data-testid="dashboard-daily-spark" className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-gold"><Sparkles className="h-4 w-4 text-gold" /> Today's Daily Spark</Link>
        <Link to="/explore" data-testid="dashboard-explore" className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-gold"><Compass className="h-4 w-4 text-gold" /> {exploreThemes ? "Explore by theme" : "Explore questions"}</Link>
      </div>
    </header>
  );
}
